export var IconName;
(function (IconName) {
    IconName["ALERT"] = "tri-alert";
    IconName["ARROW_DOWN"] = "tri-arrow-down";
    IconName["ARROW_LEFT"] = "tri-arrow-left";
    IconName["ARROW_RIGHT"] = "tri-arrow-right";
    IconName["ARROW_UP"] = "tri-arrow-up";
    IconName["BELL"] = "tri-bell";
    IconName["CHECK_CIRCLE"] = "tri-check-circle";
    IconName["CHECK"] = "tri-check";
    IconName["EXCLAMATION_CIRCLE"] = "tri-exclamation-circle";
    IconName["EYE_SLASH"] = "tri-eye-slash";
    IconName["EYE"] = "tri-eye";
    IconName["INFOS_CIRCLE"] = "tri-infos-circle";
    IconName["SEARCH"] = "tri-search";
    IconName["TIMES"] = "tri-times";
    IconName["TIMES_CIRCLE"] = "tri-times";
    IconName["TRASH"] = "tri-trash";
    IconName["PICTO_FACILITI"] = "tri-picto-faciliti";
    IconName["PICTO_HANDICAPZERO"] = "tri-picto-handicapzero";
    IconName["PICTO_LA_FIBRE"] = "tri-picto-la-fibre";
    IconName["PICTO_PAYMENT_AMERICANEXPRESS"] = "tri-picto-payment-americanexpress";
    IconName["PICTO_PAYMENT_CB"] = "tri-picto-payment-cb";
    IconName["PICTO_PAYMENT_MASTERCARD"] = "tri-picto-payment-mastercard";
    IconName["PICTO_PAYMENT_PAYPAL"] = "tri-picto-payment-paypal";
    IconName["PICTO_PAYMENT_VISA"] = "tri-picto-payment-visa";
})(IconName || (IconName = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbk5hbWVFbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9pY29uL0ljb25OYW1lRW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxRQXlCWDtBQXpCRCxXQUFZLFFBQVE7SUFDbEIsK0JBQW1CLENBQUE7SUFDbkIseUNBQTZCLENBQUE7SUFDN0IseUNBQTZCLENBQUE7SUFDN0IsMkNBQStCLENBQUE7SUFDL0IscUNBQXlCLENBQUE7SUFDekIsNkJBQWlCLENBQUE7SUFDakIsNkNBQWlDLENBQUE7SUFDakMsK0JBQW1CLENBQUE7SUFDbkIseURBQTZDLENBQUE7SUFDN0MsdUNBQTJCLENBQUE7SUFDM0IsMkJBQWUsQ0FBQTtJQUNmLDZDQUFpQyxDQUFBO0lBQ2pDLGlDQUFxQixDQUFBO0lBQ3JCLCtCQUFtQixDQUFBO0lBQ25CLHNDQUEwQixDQUFBO0lBQzFCLCtCQUFtQixDQUFBO0lBQ25CLGlEQUFxQyxDQUFBO0lBQ3JDLHlEQUE2QyxDQUFBO0lBQzdDLGlEQUFxQyxDQUFBO0lBQ3JDLCtFQUFtRSxDQUFBO0lBQ25FLHFEQUF5QyxDQUFBO0lBQ3pDLHFFQUF5RCxDQUFBO0lBQ3pELDZEQUFpRCxDQUFBO0lBQ2pELHlEQUE2QyxDQUFBO0FBQy9DLENBQUMsRUF6QlcsUUFBUSxLQUFSLFFBQVEsUUF5Qm5CIn0=